module.exports = __webpack_public_path__ + "img/img-2.243b4221.png";